import { RESET_STATE } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import {
    ALL_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED,
    EditRegulationPanelState,
    EditRegulationTypes,
    TOGGLE_EDITABLE_CURB_LINK,
    ALL_PROPOSED_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED
} from "../../actions/regulation/EditRegulation/types";
import { defaultGetResponse } from "../../interfaces/ActionReducer/GetMethod/GetResponse";

const initialState: EditRegulationPanelState = {
    curbLinksWithSameRegulationID: defaultGetResponse,
    isEditCurbLinkEnabled: false
};

const editRegulation = (
    state: EditRegulationPanelState = initialState,
    action: EditRegulationTypes
) => {
    switch (action.type) {
        case TOGGLE_EDITABLE_CURB_LINK: {
            return {
                ...state,
                isEditCurbLinkEnabled: action.payload.isEditCurbLinkEnabled
            };
        }

        case ALL_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED: {
            return {
                ...state,
                curbLinksWithSameRegulationID: action.payload.curbLinks
            };
        }

        case ALL_PROPOSED_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED: {
            return {
                ...state,
                proposedCurbLinksWithSameRegulationID: action.payload.curbLinks
            };
        }

        case RESET_STATE: {
            return {
                ...initialState
            };
        }

        default:
            return state;
    }
};

export default editRegulation;
